import { OnInit, Component } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { environment } from '../../environments/environment';
import { QuestionsService } from '../services/questions.service';
import { Config } from '../common/config';
import { Router } from '@angular/router';
import { SharedService } from '../services/shared.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as crypto from 'crypto-js';
import moment from 'moment-timezone';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

interface QuestionOption {
    id: number;
    OptionText: string;
}

interface Question {
    id: number;
    QuestionKey: string;
    QuestionText: string;
    QuestionType: string;
    QuestionOptions?: QuestionOption[];
}

declare function loadOpininonRoute(
    req: any,
    event: any,
    country: any,
    postalcode: any,
    channel: any,
    apiFlag: any
): any;
declare let opinionRouteResponse: any;

@Component({
    selector: 'app-router',
    standalone: true,
    imports: [
        MatProgressSpinnerModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    templateUrl: './router.component.html'
})
export class RouterComponent implements OnInit {
    public config: any = Config;
    private urlPath: any;
    public routeParams: any;
    private splitUrlPath: any;
    public allQuestions: Question[] = [];
    public displayQuestions: Question[] = [];
    public payload: Record<string, string> = {};
    public currentQuesIndex = 0;
    public totalQues!: number;
    public pid: string | null = null;
    public ipAddress: any;
    public demographic: any = {
        ZIPCODES: { selected_opt: '', selected_optionText: '' },
        AGE: { selected_opt: '', selected_optionText: '' },
        DMA_CODE: { selected_opt: '', selected_optionText: '' },
    };
    private device = '';
    public opinionRoute: any;
    public rd: any;
    public countryCode: any;
    public invalidZipcodeMsg: string = '';
    public zipCodeExists: boolean = false;
    public validatedQuestions: boolean[] = [];
    public token: any;
    public isDisableSubmit: boolean = false;
    public aid: any;
    public offerid: any;
    public supCode: any;
    public viewLoading: boolean = true;
    public matchParam: any = [];
    public countryName: string = '';
    public isSupCode: boolean = false;
    public isStartHeading = false;
    public isValid = true;
    public isURL = false;
    public affSub: any;
    public trackId: any;
    private updatedPayload: boolean = false;
    public isNextResponse: boolean = false;
    private isData: boolean = false;
    private custVar1: any;
    public rdResponseReady: boolean = false;

    constructor(
        private readonly questionService: QuestionsService,
        public sharedService: SharedService,
        private readonly deviceService: DeviceDetectorService,
        private readonly router: Router
    ) {
        this.deviceInfo();
    }

    public ngOnInit() {
        this.urlPath = globalThis.location.href;
        this.splitUrlPath = this.urlPath.split('?');
        this.routeParams = new URLSearchParams(this.splitUrlPath[1]);

        this.pid = this.routeParams.get('PID');
        this.aid = this.routeParams.get('aid');
        this.offerid = this.routeParams.get('offerid');
        const paramValue = Number(this.routeParams.get('supCode'));
        this.supCode = Number.isNaN(paramValue) ? 'FEsupplier' : paramValue;
        this.affSub = this.routeParams.get('aff_sub');
        this.trackId = this.routeParams.get('trackId');
        this.custVar1 = this.routeParams.get('custVar1');
        
        if (environment.HOSupplierCode.includes(this.supCode)) {
            if (!(
                this.pid &&
                this.supCode &&
                this.aid &&
                this.offerid &&
                this.affSub &&
                this.trackId
            )) {
                this.viewLoading = false;
                this.isURL = true;
                return;
            }
        }
        if (!(this.pid && this.supCode)) {
            this.viewLoading = false;
            this.isSupCode = true;
            return;
        }

        this.getToken().then(() => this.handleAfterToken());
    }

    private handleAfterToken() {
        if (!this.isValidPid(this.pid)) return;
    
        this.isStartHeading = true;
    
        this.extractQuestionParams();
        this.loadQuestionsAndPopulate();
    
        loadOpininonRoute(
            this.pid,
            environment.opinionRoute.eventId,
            this.countryCode,
            null,
            this.supCode,
            environment.DFIQ_S2S_API_ENABLED
        );
    }

    private extractQuestionParams() {
        for (const [key, value] of this.routeParams.entries()) {
            if (!environment.questionKeys.includes(key)) continue;
    
            this.matchParam.push(key);
            this.payload[key] = value;
    
            if (key === 'AGE' && value > this.config.ageRange.min && value < this.config.ageRange.max) {
                this.setDemographicValue(key, value);
            }
    
            if (key === 'ZIPCODES') {
                this.setDemographicValue(key, value);
            }
        }
    }
    
    private setDemographicValue(key: string, value: any) {
        this.demographic[key].selected_opt = value;
        this.demographic[key].selected_optionText = value;
    }

    private loadQuestionsAndPopulate() {
        this.getQuestions().then(() => {
            if (this.matchParam.length) {
                this.populatedQSP(this.matchParam);
            }
        });
    }    

    private getRDResponse() {
        return new Promise<void>((resolve, reject) => {
            if (this.pid) {
                const obj: any = { id: this.pid };
                if (opinionRouteResponse?.forensic) {                    
                    this.opinionRoute = environment.DFIQ_S2S_API_ENABLED
                                      ? opinionRouteResponse.forensic.id 
                                      : structuredClone(opinionRouteResponse.forensic);
                    opinionRouteResponse = null;
                }
                opinionRouteResponse = null;
                this.sharedService.getRDToken(obj).subscribe({
                    next: (response: any) => {
                        if (response?.results.length) {
                            this.token = response.results[0].token;
                            obj['token'] = this.token;
                            obj['surveyID'] = crypto
                                .SHA256(moment().startOf('month').format('DD-MM-YYYY'))
                                .toString();

                            this.sharedService.getRDDetails(obj).subscribe((rdData: any) => {
                                    this.rd = rdData;
                                    this.rdResponseReady = true;
                                    if (this.matchParam.length === this.totalQues) {
                                        this.populatedQSP(this.matchParam);
                                    }
                                    resolve();
                            });
                        }
                    },
                    error: (error) => {
                        console.error('Error fetching RD response', error);
                        reject(new Error(error?.message || error));;
                    },
                });
            }
        });
    }

    private getToken() {
        return new Promise<void>((resolve, reject) => {
            this.getIpInfo().then(() => {
                this.sharedService
                    .getGeoLocation({ ip: this.ipAddress })
                    .subscribe((response: any) => {
                        if (!response?.location?.countryData?.name) {
                            console.error('Error fetching country full Name info');
                            return reject(new Error('Error fetching country full Name info'));
                        }
                        this.countryName = response.location.countryData.name;
                        this.countryCode = response.location.country;
                        resolve();
                    });
            });
        });
    }

    private getIpInfo() {
        return new Promise<void>((resolve, reject) => {
            this.sharedService
                    .getUserIp()
                    .subscribe({
                    next: (response : any) => {
                        this.ipAddress = response.result.ip;
                            resolve();
                        },
                        error: (error) => {
                        console.error('Error fetching IP info', error);
                        reject(new Error(error?.message || error));;
                    },
                    });
        });
    }

    private isValidPid(pid: string | null): boolean {
        return pid !== null && pid.length > 0;
    }

    public async populatedQSP(matchParams: any) {
        this.handleForensicRoute();
        this.viewLoading = true;
    
        const skipQuestions: string[] = [];
    
        for (const question of this.displayQuestions) {
            const key = question.QuestionKey;
            if (!matchParams.includes(key)) continue;
    
            skipQuestions.push(key);
    
            const valid = await this.handleSingleQuestion(question, matchParams, skipQuestions);
            if (!valid) continue;
        }
    
        const allValid = this.displayQuestions.every(q =>
            matchParams.includes(q.QuestionKey)
        );
    
        if (!allValid && !this.updatedPayload) {
            this.viewLoading = false;
            this.displayQuestions = this.displayQuestions.filter(
                (item: any) => !skipQuestions.includes(item.QuestionKey)
            );
            this.totalQues = this.displayQuestions.length;
            return;
        }
    
        if (!this.isData) {
            await this.storePanelistProfiling();
        }
    
        this.submitForm();
    }
    
    private handleForensicRoute() {
        if (opinionRouteResponse?.forensic) {
            this.opinionRoute = environment.DFIQ_S2S_API_ENABLED
                ? opinionRouteResponse.forensic.id
                : structuredClone(opinionRouteResponse.forensic);
    
            opinionRouteResponse = null;
        }
    }
    
    private async handleSingleQuestion(question: any, matchParams: any[], skipQuestions: string[]) {
        const key = question.QuestionKey;
    
        if (key === 'ZIPCODES' && !this.updatedPayload) {
            const validZip = await this.validateZipAndMoveNext();
            if (!validZip) {
                this.resetDemographic(key);
                this.removeFromMatch(key, matchParams, skipQuestions);
                return false;
            }
            await this.zipMasterData();
        }
    
        await this.mapOptionTextIfNeeded(question, matchParams, skipQuestions);
        this.validateAge(question, matchParams, skipQuestions);
    
        return true;
    }
    
    private async mapOptionTextIfNeeded(question: any, matchParams: any[], skipQuestions: string[]) {
        const key = question.QuestionKey;
        const questionType = question.QuestionType;
    
        for (const payloadKey in this.payload) {
            if (payloadKey !== key) continue;
    
            const isDropdown = questionType === this.config.questionTypes[0];
            if (!isDropdown) continue;
    
            const selectedOption = question.QuestionOptions?.find(
                (opt: any) => opt.id == this.payload[key]
            );
    
            if (selectedOption) {
                this.payload[key] = selectedOption.OptionText;
            } else {
                delete this.payload[key];
                this.removeFromMatch(key, matchParams, skipQuestions);
            }
        }
    }
    
    private validateAge(question: any, matchParams: any[], skipQuestions: string[]) {
        if (question.QuestionKey !== 'AGE') return;
    
        const age = Number.parseInt(this.payload['AGE'], 10);
        if (Number.isNaN(age) || age < this.config.ageRange.min || age > this.config.ageRange.max) {
            delete this.payload['AGE'];
            this.removeFromMatch('AGE', matchParams, skipQuestions);
        }
    }
    
    private resetDemographic(key: string) {
        this.demographic[key].selected_opt = '';
        this.demographic[key].selected_optionText = '';
    }
    
    private removeFromMatch(key: string, matchParams: any[], skipQuestions: string[]) {
        const idx = matchParams.indexOf(key);
        if (idx > -1) matchParams.splice(idx, 1);
    
        const skipIdx = skipQuestions.indexOf(key);
        if (skipIdx > -1) skipQuestions.splice(skipIdx, 1);
    }

    public getQuestions() {
        return new Promise<void>((resolve, reject) => {
            this.sharedService
                .getProfilingQuestions(this.pid, this.supCode)
                .subscribe({
                    next: (response: any) => {
                        if (response?.result?.Qualifications) {
                            const qualifications = response.result.Qualifications;
                            if (qualifications) {
                                this.initQuestions().then(() => {
                                    this.processQualifications(qualifications);
                                });
                            }
                        } else {
                            this.initQuestions().then(() => {
                                this.isData = true;
                                resolve();
                            });
                        }
                    },
                    error: (error) => {
                        this.viewLoading = false;
                        this.isSupCode = true;
                        reject(new Error(error?.message || error));;
                    },
                });
        });
    }

    private async processQualifications(qualifications: any[]): Promise<void> {
        this.updatedPayload = this.displayQuestions.every(
            (question) =>
                qualifications.some(
                    (qualification: any) =>
                        qualification.QuestionKey === question.QuestionKey
                )
        );
        
        const ageValue = Number.parseInt(this.payload['AGE']);
        if (Number.isNaN(ageValue) || ageValue < this.config.ageRange.min || ageValue > this.config.ageRange.max) {
            delete this.payload['AGE'];
        }

        await this.processZipIfNeeded();

        this.payload = qualifications.reduce(
            (acc: any, qualification: any) => {
                for (const opt of qualification.Options) {
                    if (!acc.hasOwnProperty(qualification.QuestionKey)) {
                        acc[qualification.QuestionKey] = opt.OptionId;
                    }
                }
                return acc;
            },
            this.payload
        );

        for (const qualification of qualifications) {
            this.setDemographicFromQualification(qualification);
            this.matchParam.push(qualification.QuestionKey);
        }
        
        this.populatedQSP(this.matchParam);
    }

    private setDemographicFromQualification(qualification: any): void {
        const questionKey = qualification.QuestionKey;
        const demographicKeys = ['AGE', 'ZIPCODES', 'DMA_CODE'];
        
        if (demographicKeys.includes(questionKey) && !this.demographic[questionKey].selected_opt) {
            const optionText = qualification.Options[0].OptionText;
            this.demographic[questionKey].selected_opt = optionText;
            this.payload[questionKey] = optionText;
        }
    }

    public async initQuestions(): Promise<void> {
        const response = await this.getQuestionsResponse();
        this.getRDResponse();
        this.processQuestionsResponse(response);
    }

    private getQuestionsResponse(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.questionService
                .getQuestionsByIds({
                    ids: environment.questionIds,
                    country: this.countryCode,
                    language: this.config.selectedLng,
                    limit: 12,
                })
                .subscribe({
                    next: (response: any) => resolve(response),
                    error: (error: any) => reject(new Error(error?.message || error)),
                });
        });
    }

    private processQuestionsResponse(response: any): void {
        this.viewLoading = this.matchParam.length > 0;
        this.allQuestions = response.question as Question[];
        this.sortQuestions();
        this.filterDisplayQuestions();
        this.totalQues = this.displayQuestions.length;
    }

    private sortQuestions(): void {
        this.allQuestions.sort((a, b) => {
            return (
                environment.questionKeys.indexOf(a.QuestionKey) -
                environment.questionKeys.indexOf(b.QuestionKey)
            );
        });
    }

    private filterDisplayQuestions(): void {
        this.displayQuestions = this.allQuestions.filter(
            (item: any) => !this.config.masterZipQues.includes(item.QuestionKey)
        );
    }

    async nextQuestion(onSubmit = false) {
        this.isNextResponse = true;
        const currentQuestion = this.displayQuestions[this.currentQuesIndex];
        let question_key = currentQuestion.QuestionKey;
        this.isValid = true;

        if (!this.payload[question_key]) {
            this.isValid = false;
            this.validatedQuestions[this.currentQuesIndex] = true;
            this.isNextResponse = false;
        }

        // Age validation
        if (question_key === 'AGE') {
            const age = Number.parseInt(this.payload['AGE'], 10);
            if (Number.isNaN(age) || age < this.config.ageRange.min || age > this.config.ageRange.max) {
                this.isValid = false;
                this.validatedQuestions[this.currentQuesIndex] = true;
                this.isNextResponse = false;
                return;
            }
        }

        if (question_key === 'ZIPCODES') {
            if (!this.demographic['ZIPCODES']?.selected_opt) {
                this.isValid = false;
                this.validatedQuestions[this.currentQuesIndex] = true;
                this.isNextResponse = false;
                return;
            }

            const isValidZip = await this.validateZipAndMoveNext();
            if (!isValidZip) {
                this.isValid = false;
                this.validatedQuestions[this.currentQuesIndex] = true;
                this.isNextResponse = false;
                return;
            }
            await this.zipMasterData();
        }

        if (opinionRouteResponse?.forensic) {
            this.opinionRoute = environment.DFIQ_S2S_API_ENABLED
                              ? opinionRouteResponse.forensic.id 
                              : structuredClone(opinionRouteResponse.forensic);
            opinionRouteResponse = null;
        }

        if (this.isValid && !onSubmit) {
            await this.storePanelistProfilingDetails();
            this.isStartHeading = false;
        }
    }

    public previousQuestion() {
        if (this.currentQuesIndex > 0) {
            this.currentQuesIndex--;
        }

        if (this.currentQuesIndex === 0) {
            this.isStartHeading = true;
        }

        if (
            this.displayQuestions[this.currentQuesIndex]?.QuestionKey === 'ZIPCODES'
        ) {
            this.validatedQuestions[this.currentQuesIndex] = true;
        }
    }

    public masterZipCode(masterZipObj: any) {
        return new Promise<void>((resolve, reject) => {
            masterZipObj['cnt'] = this.countryCode;

            this.sharedService.getZipcodeData(masterZipObj).subscribe({
                next: (zipResp: any) => {
                    if (!zipResp?.data) {
                        return resolve();
                    }
                    const zipMasterData = this.sharedService.commonDecryptionMethod(zipResp.data);

                    if (zipMasterData) {
                        this.payload['STATE'] = zipMasterData.stName || '';
                        this.payload['REGION'] = zipMasterData.rgn || '';
                        this.payload['DMA_NAME'] = zipMasterData.dmaName || '';
                    }

                    if (this.demographic['DMA_CODE']) {
                        this.demographic['DMA_CODE'].selected_opt = zipMasterData.dma || '';
                        this.demographic['DMA_CODE'].selected_optionText =
                            zipMasterData.dma || '';
                        this.payload['DMA_CODE'] = zipMasterData.dma || '';
                    }
                    resolve();
                },
                error: (error) => {
                    console.error('Error fetching zipcode data:', error);
                    reject(new Error(error?.message || error));;
                },
            });
        });
    }

    // fetching device info
    deviceInfo() {
        switch(true){
          case this.deviceService.isTablet():
              this.device = 'Tablet';
              break;
          case this.deviceService.isMobile():
              this.device = 'Mobile';
              break;
          case this.deviceService.isDesktop():
              this.device = 'Desktop';
              break;
          default:
              this.device = '';
              break;
        }
    }

    public async storePanelistProfiling() {
        const transData = {
            dfiqFngrScrDvc: {
                deviceId: this.opinionRoute?.deviceId,
                crtdOn: new Date(),
                score: this.opinionRoute?.marker?.score,
            },
            rdFngrScrDvc: {
                respondent_ud: this.rd.Respondent.respondent_ud,
                crtdOn: new Date(),
                threat_potential_score: this.rd.Respondent.threat_potential_score,
            },
        };

        const panelistProfileObj = {
            token: this.token,
            PID: this.pid,
            toUpdatePnlst: {
                deviceId: this.opinionRoute?.deviceId,
                PID: this.pid,
                respondent_ud: this.rd.Respondent.respondent_ud,
            },
            toUpdateStats: {
                scTotal: 1,
            },
            transData: transData,
            aid: this.aid,
            offerId: this.offerid,
            aff_sub: this.affSub,
            trackId: this.trackId,
            opinionRouteResponse: this.opinionRoute,
            rdResponse : this.rd,
            firstUserIP : this.ipAddress,
            isS2SAPIEnabled : environment.DFIQ_S2S_API_ENABLED
        };

        const s2senabledPanelistProfileObj = {
            token: this.token,
            PID: this.pid,
            toUpdatePnlst: {
                PID: this.pid,
                respondent_ud: this.rd.Respondent.respondent_ud,
            },
            toUpdateStats: {
                scTotal: 1,
            },
            transData: {
                rdFngrScrDvc: {
                    respondent_ud: this.rd.Respondent.respondent_ud,
                    crtdOn: new Date(),
                    threat_potential_score: this.rd.Respondent.threat_potential_score,
                }
            },
            aid: this.aid,
            offerId: this.offerid,
            aff_sub: this.affSub,
            trackId: this.trackId,
            opinionRouteResponse: this.opinionRoute,
            rdResponse : this.rd,
            firstUserIP : this.ipAddress,
            isS2SAPIEnabled : environment.DFIQ_S2S_API_ENABLED
        };

        const finalPayload = environment.DFIQ_S2S_API_ENABLED ?  s2senabledPanelistProfileObj : panelistProfileObj;

        this.sharedService
            .addUpdatePanelistProfiling(this.pid, finalPayload, this.supCode)
            .subscribe({
                next: () => {
                    console.log('Panelist Details stored.');
                },
                error: (error) => {
                    console.error('Error saving data:', error);
                },
            });
    }

    public async submitForm() {
        this.isDisableSubmit = true;
        await this.nextQuestion(true);
        if (!this.isValid) {
            this.isDisableSubmit = false;
            return;
        }
        const lastQuestion: any = this.displayQuestions.at(-1);

        if (!this.payload[lastQuestion?.QuestionKey]) {
            this.validatedQuestions[this.currentQuesIndex] = true;
            this.isDisableSubmit = false;
            return;
        }
        if(this.totalQues !== this.displayQuestions.length || !this.updatedPayload || this.matchParam.length !== this.displayQuestions.length) {
            await this.storePanelistProfilingDetails();
        }
        await this.getPIM(this.pid);
    }

    async getPIM(pid: any) {
        const payload :any = {
            ip: this.ipAddress,
            numSurveys: this.config.numberOfSurvey,
            deviceType: this.device,
            trackId: this.trackId
        };
        this.custVar1 && (payload.custVar1 = this.custVar1);
        this.sharedService
            .personaliseModelInventroy(pid, payload, this.supCode)
            .subscribe({
                next: (response: any) => {
                    if (!response?.surveys?.length) {
                        this.router.navigate(['/Survey-Complete']);
                        this.viewLoading = false;
                        return;
                    }
                    const survey = response.surveys;
                    if (survey?.length) {
                        this.isDisableSubmit = false;
                        const entryLink = survey[0].entryLink;
                        if (entryLink) {
                            globalThis.location.href = entryLink;
                        }
                    }
                },
                error: (error) => {
                    console.error('Error saving PMI data:', error);
                    this.router.navigate(['/Survey-Complete']);
                },
            });
    }

    async validateZipAndMoveNext(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.zipCodeExists = false;
            let answer: any = this.demographic['ZIPCODES']?.selected_opt?.trim();

            // Format answer based on ZIP code value
            answer = Number.isNaN(answer) ? answer.toUpperCase() : answer;

            if (answer && this.countryCode === this.config.selectedCnt) {
                this.sharedService
                    .checkZipcodeValidation(this.countryCode, answer, this.supCode)
                    .subscribe({
                        next: (res: any) => {
                            if (res?.result.zipCodeExists) {
                                this.zipCodeExists = true;
                                this.invalidZipcodeMsg = '';
                                resolve(true);
                            } else {
                                this.invalidZipcodeMsg =
                                    'The ZIP code you entered is not valid. Please enter a valid ZIP code.';
                                resolve(false);
                            }
                        },
                        error: (err: any) => {
                            reject(new Error(err?.message || err));
                        },
                    });
            } else {
                resolve(true);
            }
        });
    }

    public async storePanelistProfilingDetails(): Promise<void> {
        ++this.currentQuesIndex;
        return new Promise((resolve, reject) => {
        const questions = (this.matchParam.length || this.countryCode === this.config.selectedCnt) ? this.allQuestions : this.displayQuestions;
        const qualifications = questions.map((question) => {
            const options = [];
            if (question.QuestionType === this.config.questionTypes[0]) {
                const selectedOption = question.QuestionOptions?.find(
                    (option) => option.OptionText === this.payload[question.QuestionKey]
                );
                if (selectedOption) {
                    options.push({
                        OptionId: selectedOption.id,
                        OptionText: selectedOption.OptionText,
                    });
                }
            }

            if (
                ['AGE', 'ZIPCODES', 'DMA_CODE'].includes(question.QuestionKey) &&
                this.demographic[question.QuestionKey]?.selected_opt
            ) {
                options.push({
                    OptionText: this.demographic[question.QuestionKey].selected_opt,
                });
            }
            return {
                QuestionId: question.id,
                QuestionKey: question.QuestionKey,
                Options: options,
            };
        });

        const payload = {
            Country: this.countryName,
            Language: this.config.selectedLng,
            Qualifications: qualifications.filter((q) => q.Options.length),
        };

        this.sharedService
            .setProfilingQuestions(this.pid, payload, this.supCode)
            .subscribe({
                next: () => {
                    if (this.currentQuesIndex === 1 && !this.updatedPayload) {
                        (async () => {
                            try {
                                await this.storePanelistProfiling();
                            } catch (error: any) {
                                return reject(new Error(error?.message || error));
                            }
                        })();
                    }
                    this.isNextResponse = false;
                    return resolve();
                },
                error: (error) => {
                    this.router.navigate(['/Survey-Complete']);
                    console.error('Error saving data:', error);
                    return reject(new Error(error?.message || error));;
                },
            });
        });
    }

    private async zipMasterData() {
        if (this.countryCode === this.config.selectedCnt) {
            await this.masterZipCode({
                id: this.demographic['ZIPCODES']?.selected_opt.toString(),
            });
        }
    }

    private async processZipIfNeeded() {
        const zip = this.payload['ZIPCODES'];
        if (!zip) return;
    
        const isValid = await this.validateZipAndMoveNext();
        if (!isValid) {
            delete this.payload['ZIPCODES'];
            this.demographic['ZIPCODES'].selected_opt = '';
            return;
        }
    
        await this.zipMasterData();
    }
}
